import React from 'react';

/**
 * interface for the app context.
 */
interface AppContextProps {
	/**
	 * Hold the status of the expiration alert counter.
	 *
	 * @type {boolean}
	 * @memberof AppContext
	 */
	expirationAlertCountdownStarted: boolean;

	/**
	 * Sets the value of the expiration status counter.
	 *
	 * @memberof AppContext
	 */
	setExpirationAlertCountdownStarted: (started: boolean) => void;
}

export default React.createContext<Partial<AppContextProps>>({});
